<div class="p-md">
  <fl-task-analysis-statistic></fl-task-analysis-statistic>
  <!-- 个性错题不支持发布消息：对它而言这张卡片只剩「任务反馈」一个可见 tab（其余 tab 本就 hidden），故整卡不渲染 -->
  @if (task && task?.type !== TaskTypeEnum.BookletOfPerson) {
    <fl-task-analysis-chart
      (changeNo)="changeQuestion($event)"
      [task]="task"
      [currentQuestionNo]="currentQuestionNo"
      [messageStatis]="taskMessageStatis"
    ></fl-task-analysis-chart>
  }
  @if (!taskAnalysisSrv.taskAnalysisQuestionEmpty) {
    @if (![TaskTypeEnum.BookletOfPerson, TaskTypeEnum.QuickUptake].includes($safeNavigationMigration(task?.type))) {
      <div class="mt-[16px]" nz-row>
        <div
          nz-col
          nzFlex="1"
          class="rounded-tl-[6px] rounded-bl-[6px]"
          style="background: #fff; overflow: hidden; box-shadow: 0 0 0 0.5px #dfe5f0"
        >
          @if (question) {
            <fl-question
              [question]="question"
              [single]="!!childQuestion"
              [displayType]="'inline'"
              [insideScroll]="true"
              [extraAfter]="questionAudioTpl"
              [contentMinHeight]="400"
              [title]="{ stemTpl: questionStemTitleTpl }"
              [action]="childQuestion ? [] : ['collect', 'similar', quickUptakeTpl, 'select', 'more']"
              #questionTpl
            >
              <ng-template #questionAudioTpl>
                <fl-task-question-toolbar [question]="question" [taskId]="task.id"></fl-task-question-toolbar>
                @if (
                  (taskAnalysisSrv.task | async)?.bookletTaskType &&
                  (taskAnalysisSrv.task | async)?.bookletTaskType !== TaskType.Unset
                ) {
                  <fl-question-booklet-important
                    [questionId]="question.id"
                    [taskId]="task.id"
                    [isChecked]="currentQuestionStatis.preferred"
                    [task]="task"
                    (checkedChange)="bookletImportChange($event)"
                  ></fl-question-booklet-important>
                }
              </ng-template>
              <ng-template #quickUptakeTpl>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  (click)="onQuickUptake(question)"
                  [disabled]="question.content === '' || !questionStatis || questionStatis?.answers?.length <= 0"
                >
                  <i nz-icon nzType="partition" nzTheme="outline"></i>
                  举一反三
                </button>
              </ng-template>
              <!-- <ng-template #aiVariantTpl>
                @if (isShowAiQuestion) {
                  <button
                    nz-button
                    nzType="link"
                    nzSize="small"
                    (click)="onAiVariant(question)"
                    [disabled]="question.content === ''"
                  >
                    <i nz-icon nzType="robot" nzTheme="outline"></i>
                    AI变式
                  </button>
                }
              </ng-template> -->
              <ng-template #questionStemTitleTpl>
                <fl-question-title
                  [question]="question"
                  [no]="stemQuestionNo || currentQuestionNo"
                  (lecture)="enlargeQuestion()"
                >
                </fl-question-title>
              </ng-template>
            </fl-question>
          }
          @if (childQuestion) {
            <fl-question
              [question]="childQuestion"
              [extraAfter]="questionAudioTpl"
              [title]="{ stemTpl: questionChildTitleTpl }"
              [action]="['similar', quickUptakeTpl, aiVariantTpl, 'more']"
            >
              <ng-template #questionAudioTpl>
                <fl-task-question-toolbar [question]="childQuestion" [taskId]="task.id"></fl-task-question-toolbar>
              </ng-template>
              <ng-template #questionChildTitleTpl>
                <fl-question-title
                  [question]="childQuestion"
                  [no]="currentQuestionNo"
                  (lecture)="enlargeQuestion()"
                ></fl-question-title>
              </ng-template>
              <ng-template #quickUptakeTpl>
                <button
                  nz-button
                  nzType="primary"
                  (click)="onQuickUptake(childQuestion)"
                  [disabled]="childQuestion.content === '' || !questionStatis || questionStatis?.answers?.length <= 0"
                >
                  <i nz-icon nzType="partition" nzTheme="outline"></i>
                  举一反三
                </button>
              </ng-template>
              <ng-template #aiVariantTpl>
                <button
                  nz-button
                  nzType="primary"
                  (click)="onAiVariant(childQuestion)"
                  [disabled]="childQuestion.content === ''"
                >
                  <i nz-icon nzType="robot" nzTheme="outline"></i>
                  AI变式
                </button>
              </ng-template>
            </fl-question>
          }
        </div>
        <div nz-col nzFlex="500px" class="question-detail bg-white rounded-tr-[6px] rounded-br-[6px]">
          <div class="p-[10.5px_20px] border-b border-[#F0F0F0]">
            <lib-fl-tabs
              [tabs]="resultTabs"
              [(ngModel)]="questionTabIndex"
              (ngModelChange)="tabsChange($event)"
            ></lib-fl-tabs>
          </div>
          <div class="p-[12px_16px] question-detail-content">
            <!-- AI阅卷信息 -->
            @if (questionStatis?.aimarkStatus) {
              <div class="flex items-center">
                <div class="w-[4px] h-[12px] bg-primary-b1 mr-[8px] rounded-[2px] flex-shrink-0"></div>
                <div class="flex-shrink-0">
                  <img [src]="aiAvatar" alt="阅卷智能体信息" class="size-6" />
                  <span class="text-neutral-n1 font-medium ml-2">{{ questionStatis?.aimarkStatus.prompt }}</span>
                  <span class="ml-4 text-neutral-n3">{{
                    questionStatis?.aimarkStatus.status | algoJobStatus
                  }}</span>
                </div>
                <nz-divider class="ml-[8px] flex-1 min-w-0 border-neutral-n5"></nz-divider>
              </div>
              <div
                class="flex items-center rounded px-2 py-1 justify-between"
                [class]="
                  questionStatis?.aimarkStatus.status === AlgoJobStatusEnum.JOB_FAILED
                    ? 'bg-red-r6'
                    : questionStatis?.aimarkStatus.appealCount > 0
                      ? 'bg-orange-o6'
                      : 'bg-neutral-n9'
                "
              >
                <div class="flex gap-5">
                  <span class="text-neutral-n2">
                    给分：{{ questionStatis?.aimarkStatus.succeedCount }} / {{ questionStatis?.submitCount }}
                  </span>
                  <span class="text-neutral-n2">
                    合理：{{ questionStatis?.aimarkStatus.succeedCount - questionStatis?.aimarkStatus.appealCount }}
                  </span>
                  <span class="text-neutral-n2">不合理：{{ questionStatis?.aimarkStatus.appealCount }}</span>
                  <span class="text-neutral-n2">
                    待阅：{{ questionStatis?.unmarkCount + questionStatis?.aimarkStatus.appealCount }}
                  </span>
                </div>
                <button
                  nz-button
                  flCheckLoginType
                  nzType="link"
                  nzSize="small"
                  enhanceClick
                  (click.throttle)="goMark()"
                >
                  阅卷
                </button>
              </div>
              <!-- 作答详情标题 -->
              <div class="flex items-center mt-5">
                <div class="w-[4px] h-[12px] bg-primary-b1 mr-[8px] rounded-[2px] flex-shrink-0"></div>
                <div class="text-neutral-n1 font-medium flex-shrink-0">作答详情</div>
                <nz-divider class="ml-[8px] flex-1 min-w-0 border-neutral-n5"></nz-divider>
              </div>
            }
            <!-- 作答详情 -->
            <div [id]="ResultTabsEnum.Detail">
              <div nz-row nzJustify="space-between" class="mb-md ml-[12px]">
                <div nz-col>
                  @if (questionStatisAnswers.length) {
                    <span>
                      <label
                        nz-checkbox
                        class="mr-sm text-neutral-n3"
                        [(ngModel)]="questionStatisAnswers[0].checked"
                      ></label>
                      答错{{ questionStatisAnswers[0]?.count }}人
                    </span>
                    @if (questionStatis?.medianDuration > 0) {
                      <span class="ml-1 text-neutral-n1">
                        作答时间：{{
                          questionStatis?.medianDuration | timeSpan: 'secondText'
                        }}
                        <nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip="学生用时的中位时长" />
                      </span>
                    }
                  }
                </div>
                <div nz-col>
                  <button nz-button nzType="link" nzSize="small" (click)="viewStudent($event)">
                    <i nz-icon nzType="team" nzTheme="outline"></i>
                    作答详情
                  </button>
                  <button
                    nz-button
                    nzType="link"
                    nzSize="small"
                    (click)="createTargetClassroom()"
                    [disabled]="disabledCreateTargetClass || task.scanCutMarking"
                  >
                    <i nz-icon nzType="plus-square" nzTheme="outline"></i>
                    靶向班
                  </button>
                </div>
              </div>
              @for (answer of questionStatisAnswers.slice(1); track answer.value) {
                <div nz-row nzJustify="space-between" class="mb-md ml-[12px]">
                  <div nz-col class="answer_item" nzFlex="1">
                    <label
                      style="flex: 0 0 16px"
                      nz-checkbox
                      [(ngModel)]="answer.checked"
                      [disabled]="answer.count === 0"
                    ></label>
                    <span class="mx-sm text-neutral-n3" style="flex: 0 0 50px">{{ answer.label }}</span>
                    <div class="bar_container">
                      <div
                        class="bar"
                        (click)="viewStudent($event, answer)"
                        nz-tooltip
                        [nzTooltipTitle]="
                          [QuestionType.MultiChoice].includes(questionStatis.model)
                            ? '查看答案包含' + answer.label + '的名单'
                            : ''
                        "
                        [style]="{
                          width: answer.width + '%',
                          background: answer.backgroundColor,
                        }"
                      ></div>
                      @if (questionStatis.model === QuestionType.MultiChoice) {
                        <div
                          class="un_bar"
                          [style]="{ width: 100 - answer.width + '%' }"
                          (click)="viewNotAnswerStudent($event, answer)"
                          nz-tooltip
                          [nzTooltipTitle]="
                            [QuestionType.MultiChoice].includes(questionStatis.model)
                              ? '查看答案不含' + answer.label + '的名单'
                              : ''
                          "
                        ></div>
                      }
                    </div>
                  </div>
                  <div nz-col nzFlex="48px" class="text-right text-neutral-n3">
                    <span>{{ answer.count }}人</span>
                  </div>
                </div>
              }
              <!-- 英语聚合答案显示 -->
              @if (wrongAnswers) {
                <div class="mt-lg">
                  <div nz-row nzAlign="middle" nzJustify="space-between">
                    <div class="wrongAnswerBox">
                      @for (answer of wrongAnswers; track answer.answer) {
                        <span (click)="clickWrongTab($event, answer)" class="wrongAnswer mr-md mb-md">
                          {{ answer.answer }} ({{ answer.count }})
                        </span>
                      }
                    </div>
                  </div>
                </div>
              }
              <!-- since 26.5.19 选择题拍照 -->
              @if (
                [QuestionType.SingleChoice, QuestionType.MultiChoice].includes(
                  $safeNavigationMigration(questionStatis?.model)
                ) && choiceDraftsCount > 0
              ) {
                <div class="choice-draft-entry" enhanceClick (click.throttle)="viewChoiceDraftsStudents($event)">
                  <span class="text-neutral-n2">作答照片（{{ choiceDraftsCount }}张）</span>
                  <div class="flex-1"></div>
                  <span class="text-primary-b1">查看全部 <i nz-icon nzType="right" nzTheme="outline"></i></span>
                </div>
              }
            </div>
            <!-- 标记标签 -->
            @if (flagTags.length) {
              <div class="flex flex-wrap gap-2 mt-4 ml-[12px]">
                @for (tag of flagTags; track tag.flag) {
                  <nz-tag
                    class="cursor-pointer select-none"
                    [nzColor]="tag.flag >= 200 ? 'red' : tag.flag > 1 ? 'green' : null"
                    (click)="viewFlagStudents($event, tag)"
                  >
                    {{ tag.label }} {{ tag.count }}
                  </nz-tag>
                }
              </div>
            }
            <!-- 知识分析 -->
            <div [id]="ResultTabsEnum.Node">
              <div class="flex items-center">
                <div class="w-[4px] h-[12px] bg-primary-b1 mr-[8px] rounded-[2px] flex-shrink-0"></div>
                <div class="text-neutral-n1 font-medium flex-shrink-0">知识分析</div>
                <nz-divider class="ml-[8px] flex-1 min-w-0 border-neutral-n5"></nz-divider>
              </div>
              @if (!taskQuestionGraph.length) {
                <nz-empty
                  nzNotFoundContent="题目缺少知识信息,无法归纳至知识点图谱"
                  [nzNotFoundFooter]="notFoundFooterTpl"
                >
                  <ng-template #notFoundFooterTpl>
                    <button nz-button nzSize="small" (click)="assignNode($event)">完善题目知识点</button>
                  </ng-template>
                </nz-empty>
              }
              @for (graph of displayedTaskQuestionGraph; track graph.id; let idx = $index) {
                <div class="mb-md question-graph" (click)="onTarget(graph)">
                  <div nz-row nzJustify="space-between" nzAlign="middle" class="mb-sm">
                    <div class="flex items-center" style="flex: 0 0 270px">
                      <div
                        class="w-[6px] h-[6px] rounded-[6px] mr-[6px]"
                        [ngStyle]="{ backgroundColor: getEnvaluateColor(graph.data.correctPercent) }"
                      ></div>
                      <div class="text-neutral-n1 font-medium">{{ graph.name }}</div>
                    </div>
                    <button nz-button nzType="link">靶向</button>
                  </div>
                  <div nz-row class="mb-sm text-neutral-n2">
                    <p>历史：</p>
                    <p>
                      题量 {{ graph.data.gradeExerciseCount ?? '--' }}道 / 得分率
                      {{ graph.data.gradeCorrectPercent ?? '--' }}%
                    </p>
                  </div>
                  <div nz-row class="mb-sm text-neutral-n2">
                    <p>本次：</p>
                    <p>
                      题量 {{ graph.data.exerciseCount ?? '--' }}道 / 得分率 {{ graph.data.correctPercent ?? '-' }}%
                    </p>
                  </div>
                </div>
              }

              @if (taskQuestionGraph.length > 3) {
                <div class="text-center mt-md">
                  <button nz-button nzSize="small" (click)="toggleGraphExpansion()">
                    {{ isGraphExpanded ? '收起' : '展开更多' }}
                    <i nz-icon [nzType]="isGraphExpanded ? 'up' : 'down'"></i>
                  </button>
                </div>
              }
            </div>
            <!-- 题目反馈 -->
            @if (messageThreadQuery) {
              <div [id]="ResultTabsEnum.Feedback" class="flex h-full flex-col">
                <!-- 标题行 -->
                <div class="flex shrink-0 items-center">
                  <div class="w-[4px] h-[12px] bg-primary-b1 mr-[8px] rounded-[2px] flex-shrink-0"></div>
                  <div class="text-neutral-n1 font-medium flex-shrink-0">题目反馈</div>
                  <nz-divider class="ml-[8px] flex-1 min-w-0 border-neutral-n5"></nz-divider>
                </div>
                <!-- 顶部：题号 + 得分率 + tag 分组人数 -->
                <fl-task-message-static
                  [current]="currentStatisItem"
                  [messages]="currentQuestionMessages"
                  [showGoDetail]="false"
                ></fl-task-message-static>
                <div class="mt-[8px] flex-1 min-h-[160px]">
                  <fl-message-list
                    variant="inline"
                    [threadQuery]="messageThreadQuery"
                    [refreshTick]="messageRefreshTick"
                    (messagesChange)="onQuestionMessagesChange($event)"
                    (avatarClick)="onMessageAvatarClick($event)"
                    (threadOpened)="onQuestionThreadOpened($event)"
                  ></fl-message-list>
                </div>
                <!-- 底部回复区：文档流，消息流下方，常驻显示（与消息列表一致，不悬浮） -->
                <div class="shrink-0">
                  <fl-reply-composer
                    [replyTarget]="replyTarget"
                    [clearTick]="clearTick"
                    [quote]="{}"
                    [upload]="{ scope: 'blackboard', extra: { taskId: $safeNavigationMigration(task?.id) } }"
                    (send)="onSendReply($event)"
                    (cancel)="onCancelReply()"
                  >
                    <!-- 「同步全班」勾选：由宿主通过插槽注入并自持状态（回复具体对象时才显示） -->
                    @if (replyTarget?.msgId) {
                      <label class="flex select-none items-center gap-[6px] text-[13px] text-neutral-n2" toAll>
                        <input
                          type="checkbox"
                          [(ngModel)]="toAll"
                          name="replyToAll"
                          class="accent-[var(--color-primary-b1)]"
                        />
                        同步全班
                      </label>
                    }
                  </fl-reply-composer>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
  @if ([TaskTypeEnum.BookletOfPerson, TaskTypeEnum.QuickUptake].includes($safeNavigationMigration(task?.type))) {
    <fl-task-unfinished class="mt-md" [taskId]="$safeNavigationMigration(task?.id)"></fl-task-unfinished>
  }
</div>
